export enum FrameOrdering {
  ORDERED = 'ordered',
  UNORDERED = 'unordered',
}

export enum FrameOrderingLabels {
  ORDERED = 'Frames ordered',
  UNORDERED = 'Frames unordered',
}
